import { BasicPermissionItem } from '../../PermissionItem'
import { CreateViewEditRemove, Simple } from '../../common'
import { ConcreteTestingLabs } from '../../../cimsPage/instances/concrete'

const page = ConcreteTestingLabs
const object = 'Testing Lab'

export const ViewTestingLab = Simple({
  id: '723330EB-E3C7-461C-B564-1BEBC1BEE992',
  page,
  object,
  action: 'View',
})

export const CreateTestingLab = Simple({
  id: 'DE297567-D94D-438F-8B92-3B2E0F099F7E',
  page,
  object,
  action: 'Create',
})

const labTech = 'Lab Tech'

export const EditAllTestingLab = new BasicPermissionItem({
  id: 'AB4F0117-D56F-43AC-A954-F18A50B02E5F',
  name: `Edit All ${object}s`,
  page,
  action: `associate ${labTech}s with any ${object}`,
})

export const EditLimitedTestingLab = new BasicPermissionItem({
  id: 'DE56E96C-D2C1-4F19-AB58-7D499E104ED0',
  name: `Edit Limited ${object}s`,
  page,
  action: `associate ${labTech}s with any ${object} they are associated with`,
})

export const RemoveTestingLab = Simple({
  id: 'C674AF96-61F8-42BD-9D12-8FB93EA1BDBD',
  page,
  object,
  action: 'Remove',
})

const tech = CreateViewEditRemove({
  page,
  object: labTech,
  create: 'A3E95A6F-577F-42FB-8109-3C08673B83A4',
  remove: '95209509-516B-4E14-90ED-8CF700DA185D',
  view: '43875429-A339-4B8B-9135-49F764D9E1F0',
  edit: 'CE1E3AC2-B463-4D72-8D6C-B398B55E7B47',
})

export const ViewLabTech = tech.View
export const CreateLabTech = tech.Create
export const RemoveLabTech = tech.Remove
export const EditLabTech = tech.Edit

export type TestingLabPermission =
  | typeof ViewTestingLab
  | typeof CreateTestingLab
  | typeof EditAllTestingLab
  | typeof EditLimitedTestingLab
  | typeof RemoveTestingLab
  | typeof ViewLabTech
  | typeof CreateLabTech
  | typeof RemoveLabTech
  | typeof EditLabTech
